var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend mb-3 d-flex align-center flex-wrap"},_vm._l((_vm.status),function(item){return _c('div',{key:item.name,staticClass:"legend-item d-flex align-center mr-4"},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_c('span',{staticClass:"grey1--test"},[_vm._v(_vm._s(item.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }